/*
export const StrokeForImage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={451}
      height={451}
      viewBox="0 0 451 451"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M451 225.5C451 350.04 350.04 451 225.5 451S0 350.04 0 225.5 100.96 0 225.5 0 451 100.96 451 225.5zM225.5 425C335.681 425 425 335.681 425 225.5S335.681 26 225.5 26 26 115.319 26 225.5 115.319 425 225.5 425z"
        fill="#38ABFF"
        fillOpacity={0.35}
      />
    </svg>
  )
}
*/

export const StrokeForImage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={451}
      height={451}
      viewBox="0 0 451 451"
      fill="none"
    >
    </svg>
  )
}